import newsfeedGetters from "./getters.js";
import newsfeedMutations from "./mutations.js";
import newsfeedActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      newsfeedTimestamp: null,
      posts: [],
    };
  },
  getters: newsfeedGetters,
  mutations: newsfeedMutations,
  actions: newsfeedActions,
};
